module.exports = __webpack_public_path__ + "static/media/running.cd10b259.svg";